Ext.namespace('utils.http');

utils.http = (function( $, Ext, window, undefined ){
    var public = new Object();
	
	public = {
		timeout: 600000
	};
	
    public.init = function(){
		this.jquery();
		this.extjs();		
    };
		
	public.jquery = function(){
		var _this = this;
		
		$.ajaxSetup({
			type: "POST",
			timeout: this.timeout
		});
		
		$(document).ajaxError(function(event, jqxhr, settings, thrownError) {
			_this.parseStatus(jqxhr.status);
		});
	};
		
	public.extjs = function(){
		Ext.override(Ext.data.Connection, {
			timeout: this.timeout
		});

		Ext.Ajax.on('requestexception', function(conn, response, options, e) {
			var statusCode = response.status;
			
			if(statusCode == -1) statusCode = 0; 

			this.parseStatus(statusCode);
		}, this);
    };
	
	public.parseStatus = function(code){
		var message = '';
		
		if(code == 401)
		{
			alert('認證失敗，請重新登入.');
			
			top.location.href = '../../web-admin';
			
			return ;	
		}
		
		switch (code) 
		{
			case 404 : message = '查無資料，無法進行動作.'; break;
			case 400 : message = '欄位未正確填寫.'; break;
			case 0   : message = '連線逾時，請重新操作.'; break;
			default  : message = '伺服器錯誤，請聯絡管理員.';
		}
		
		top.toastr.error(message);
    };
	
    return public;
}( jQuery, Ext, window ));


